/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Add_Frame_To_EndInputs */

const en_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase end time by one frame`)
};

const fr_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter le temps de fin d'une image`)
};

const de_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhöhe die Endzeit um ein Frame.`)
};

const it_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta l'ora di fine di un fotogramma`)
};

const ru_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте время окончания на один кадр.`)
};

const es_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar el tiempo de finalización en un cuadro`)
};

const zh_cn2_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束时间增加一帧`)
};

const ja_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了時間を1フレーム増やす`)
};

const hi_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति समय को एक फ्रेम से बढ़ाएँ`)
};

const pt_pt2_shortcut_keys_desc_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Desc_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumente o tempo final em um quadro.`)
};

/**
* | output |
* | --- |
* | "Increase end time by one frame" |
*
* @param {Shortcut_Keys_Desc_Add_Frame_To_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_add_frame_to_end = /** @type {((inputs?: Shortcut_Keys_Desc_Add_Frame_To_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Add_Frame_To_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "de") return de_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "it") return it_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "es") return es_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_add_frame_to_end(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_add_frame_to_end(inputs)
	return en_shortcut_keys_desc_add_frame_to_end(inputs)
});